import { useEffect } from 'react';

import { useCompanyLoading, useCompanyProfile } from '@aqx-core/common/services/company';
import { companyViewController } from '@aqx-core/common/services/company/controller';
import { checkIsNative } from '@aqx-core/common/validators';

const IS_NATIVE = checkIsNative();

export const useRootConfig = () => {
  const company = useCompanyProfile();
  const loading = useCompanyLoading();

  useEffect(() => {
    if (!company) {
      companyViewController.init();
    }
  }, [company]);

  useEffect(() => {
    /** This is only for web / mobile-web , as document is not exist in react-native iOS and Android  */
    if (IS_NATIVE) {
      return;
    }

    let link = document.querySelector("link[rel~='icon']");

    const faviconPath = company?.faviconPath;
    const favicon = faviconPath ? `/${faviconPath}` : '';

    if (!link && !loading) {
      link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      link.setAttribute('href', favicon);

      document.getElementsByTagName('head')[0].appendChild(link);
    }

    document.title = 'WebTrader Platform';

    if (company?.name) {
      const title = `${company.name} - WebTrader Platform`;

      document.title = title;
    }
  }, [company, loading]);
};
